import { render } from "./PdfPageSkeleton.vue?vue&type=template&id=234b27c0"
import script from "./PdfPageSkeleton.vue?vue&type=script&lang=js"
export * from "./PdfPageSkeleton.vue?vue&type=script&lang=js"

import "./PdfPageSkeleton.vue?vue&type=style&index=0&id=234b27c0&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__